<template>
  <nav 
    class="" 
    :class="menuClasses"
  >
    <div class="panel-block is-block px-0 py-0">
     
        <l-project-memory-object
          :model="model"
          :content="content"
          :canHasLocation="hasLocation"
          :objectType="objectType"
          v-if=" 
               ((creationEnabled || editionEnabled) && project.format=='PROJECT_TYPE_MEMORY')
          "
          @saveMemoryObject="$emit('saveMemoryObject')"
          @cancel="$emit('cancel')"
          @delete="deleteObject"
          @addPoint="addPoint"
          @activateMapPosition="activateMapPosition"
          @showPreview="showObjectPreview"
          
      />

        <l-project-object
          :model="model"
          :content="content"
          :canHasLocation="hasLocation"
          :objectType="objectType"
          v-if=" 
               ((creationEnabled || editionEnabled) && (project.format!='PROJECT_TYPE_GEOQUIZ' && project.format!='PROJECT_TYPE_MEMORY') )
          "
          @save="$emit('save')"
          @cancel="$emit('cancel')"
          @delete="deleteObject"
          @addPoint="addPoint"
          @activateMapPosition="activateMapPosition"
          @showPreview="showObjectPreview"
          
      />

      <l-project-group-object
          :model="model"
          :content="content"
          :canHasLocation="hasLocation"
          :objectType="objectType"
          v-if="
              ((creationEnabled || editionEnabled) && project.format=='PROJECT_TYPE_GEOQUIZ') 
          "
          @saveMulti="saveMulti"
          @cancel="$emit('cancel')"
          @delete="deleteObject"
          @addPoint="addPoint"
          @activateMapPosition="activateMapPosition"
          @showPreview="showObjectPreview"
      />

      <l-project-settings-complete
          v-if="showSettings"
          @close="$emit('close')"
          @discardChanges="$emit('discardSettingsChanges')"
          @updateProject="updateProject"
          :tileProviders="tileProviders"
      />

      <l-project-configuration-comments
          v-if="showThreadList"
          :content-owner="project.owner"
          :object-id="projectId"
          class="is-overflow-hidden"
      />

      <l-project-configuration-changes
          v-if="showHistory"
          @close="$emit('closeHistory')"
      />

      <!--<l-project-sessions-menu
          v-if="showSessions"
          @start-simulation="$emit('start-simulation')"
          :activeSession="session"
      />-->
      <l-project-active-session
          v-if="showSessionActive"
          @close="$emit('toggleActiveSession')"
          :activeSession="session"
          @editGameSession="$emit('editGameSession')"
      />
      <l-project-sessions-history
          v-if="showListSessions"
          @start-simulation="$emit('start-simulation')"
          :activeSession="session"
      />

      <project-object-list
            v-if="showObjectList"
            :items="items"
            @centerMap="centerMap($event)"
            class="object-list"
            @searchObjects="searchObjects"
            @toggleObjectList="$emit('toggleObjectList')"
        />

        <l-project-configuration-share 
            v-if="showShare"
          @close="$emit('closeShare')"
          @discardChanges="$emit('discardSettingsChanges')"
          @updateProject="updateProject"
          />

        
    </div>
  </nav>
</template>

<script>
import LProjectConfigurationChanges from '@/components/LProjectConfigurationChanges';
import LProjectConfigurationComments from '@/components/LProjectConfigurationComments';
import LProjectObject from '@/components/LProjectObject';
import LProjectGroupObject from '@/components/LProjectGroupObject';
import LProjectSettingsComplete from '@/components/LProjectSettingsComplete';
import LProjectSessionsHistory from '@/components/LProjectSessionsHistory';
import LProjectActiveSession from '@/components/LProjectActiveSession';
import ProjectObjectList from '@/components/ProjectObjectList';
import TreasurehuntObjectForm from '@/components/TreasurehuntObjectForm';
import TreasurehuntQuestionForm from '@/components/TreasurehuntQuestionForm';
import TreasurehuntClueForm from '@/components/TreasurehuntClueForm';
import LProjectConfigurationShare from '@/components/LProjectConfigurationShare';
import LProjectMemoryObject from '@/components/LProjectMemoryObject';

import _ from 'underscore';
import { TILE_PROVIDERS, DEFAULT_TILE_PROVIDER } from '@/lib/constants';

export default {
    components: {
        LProjectConfigurationChanges,
        LProjectConfigurationComments,
        LProjectObject,
        LProjectSettingsComplete,
        LProjectSessionsHistory,
        LProjectActiveSession,
        ProjectObjectList,
        TreasurehuntObjectForm,
        TreasurehuntQuestionForm,
        TreasurehuntClueForm,
        LProjectGroupObject,
        LProjectConfigurationShare,
        LProjectMemoryObject
    },
    data() {
        return {
            project: {},
            showBackground: false,
            showLayout: false,
            saving: false,
            activeTab: 'INFORMATION',
            embed: this.$route.meta.embed,
            hideLogin: this.$route.meta.hideLogin,
            tileProviders: TILE_PROVIDERS,
            defaultTileProvider: DEFAULT_TILE_PROVIDER,
        };
    },
    props: {
        items: { type: Array, default: [] },
        creationEnabled: {type: Boolean, default: false},
        editionEnabled: {type: Boolean, default: false},
        model: {type: Object, default: {}},
        content: {type: Object, default: {}},
        showSettings: {type: Boolean, default: false},
        showObjectList: {type: Boolean, default: false},
        showThreadList: {type: Boolean, default: false},
        showHistory: {type: Boolean, default: false},
        showListSessions: {type: Boolean, default: false},
        showSessionActive: {type: Boolean, default: false},
        session: {type: Object, default: {}},
        hasLocation: {type: Boolean, default: false},
        objectType: {type: String, default:''},
        hasDelete: {type: Boolean, default: false},
        showShare: {type: Boolean, default: false},
    },
    computed: {
        menuClasses(){
            let classes = "lb-left-panel";
            if(this.isMobile){
                classes = "lb-bottom-panel";
            }
            if(this.embed){
                classes += " embed-menu";
            }
            if(this.project.format=='PROJECT_TYPE_GEOQUIZ' || this.project.format=='PROJECT_TYPE_MAP'){
                classes += " map-menu";
            }
            return classes;
        },
        isMobile(){
            return this.$mq=="mobile"
        },
      projectId() {
        return this.$route.params.projectId;
      },
      enterClass() {
          return this.showBackground
              ? 'animated slideInRight'
              : 'animated slideInLeft';
      },
      showConfiguration() {
          return this.$store.getters['Project/showConfiguration'];
      },
      showPrivacy() {
          return this.$store.getters['Project/showPrivacy'];
      },
      showParticipants() {
          return this.$store.getters['Project/showParticipants'];
      },
      showChanges() {
          return this.$store.getters['Project/showChanges'];
      },
      showComments() {
          return this.$store.getters['Project/showComments'];
      },
      projectSource() {
          return this.$store.getters.project;
      },
      hasAdminPermission() {
          return this.$store.getters.project.accessLevel == 'administrator';
      },
      hasEditPermission() {
          return this.$store.getters.project.accessLevel == 'edit';
      },
      canEdit() {
          return this.hasAdminPermission || this.hasEditPermission;
      },
      hasChanges() {
          if (this.showComments || this.showChanges) {
              return false;
          }
          return !_.isEqual(this.project, this.$store.state.project);
      },
      canManageGroups() {
          return this.$store.getters.canManageGroups;
      },
      cardSize() {
          return this.$store.getters['Project/cardSize'];
      },
      /*showObjectList() {
          return this.$store.getters['Project/showObjectList'];
      },*/
    },
    watch: {
        projectSource: {
            handler: function () {
                this.project = JSON.parse(JSON.stringify(this.projectSource));
            },
            immediate: true,
        },
    },
    methods: {
        changeCardSize(size) {
            let updatedLayout = {
                ...this.project.layout,
                ...{ cardSize: size },
            };
            this.project = { ...this.project, ...{ layout: updatedLayout } };
            this.$store.dispatch('Project/changeCardSize', size);
        },
        changeProjectLayout(layout) {
            let updatedLayout = { ...this.project.layout, ...{ type: layout } };
            this.project = { ...this.project, ...{ layout: updatedLayout } };
            this.$store.dispatch('Project/changeProjectLayout', layout);
        },
        updateProject(projectData) {
            // console.log('saving changes', projectData);
            this.$emit('updateProject',projectData);
        },
        deleteObject(object){
            // console.log("send delete event object",object);
            this.$emit("delete",object);
        },
        addPoint(point){
            this.$emit('addPoint',point)
        },
        activateMapPosition(mapPositionActive){
            // console.log("map position active",mapPositionActive)
            this.$emit("activateMapPosition",mapPositionActive)
        },
        centerMap(event) {
            // console.log('event', event);
            if (event.type == 'zone') {
                if (event.shape.type == 'circle') {
                    this.$refs.editMap.map.fitBounds(
                        L.latLngBounds([
                            this.$options.filters.toLatLonFromArray(
                                event.shape.coordinates
                            ),
                        ])
                    );
                } else {
                    this.$refs.editMap.map.fitBounds(
                        L.latLngBounds(
                            this.$options.filters.toLatLonFromArray(
                                event.shape.coordinates
                            )
                        )
                    );
                }
            } else {
                this.$emit("centerMap",event)
                /*this.$refs.editMap.map.fitBounds(
                    L.latLngBounds([
                        this.$options.filters.toLatLon(event.location),
                    ])
                );*/
            }

            // this.openObject(event);
        },
        searchObjects(text){
            // console.log("text to find",text)
            this.$emit("searchObjects",text)
        },
        showPreview(){
            console.log("showpreview")
        },
        showObjectPreview(e) {
            this.$emit("showObjectPreview",e)
        },
        /*addQuestion(){
            console.log("emiting from projectConfiguration")
            this.$emit('addQuestion');
            //this.content.questions.push({});
        }*/
        saveMulti(e){
            // console.log('(pas 3) sending',e)
            this.$emit('saveMulti',e)
        }

    },
    mounted: function () {
      // console.log("project configuration mounted")
      // console.log("showShare?",this.showShare)
    },
};
</script>

<style scoped>
@import '../assets/css/project-configuration.css';

</style>
